import React, { Suspense } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import './lib/i18n'; // Import i18n configuration
const container = document.getElementById('root');
if (!container) throw new Error('Failed to find the root element');
const root = createRoot(container);
root.render(<React.StrictMode data-id="element-1057">
    <Suspense fallback="Loading..." data-id="element-1058">
      <App data-id="element-1059" />
    </Suspense>
  </React.StrictMode>);